/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import styled from "styled-components";

const ItemWrapper = styled.div`
  display: flex;
  width: min-content;
  padding: 3px 5px;
  background-color: #e8e8e8;
  transition: 0.2s ease;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 700;
  position: relative;
  margin: 3px;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #e0e0e0;
  }
`;

const ValueWrapper = styled.div`
  padding-right: 23px;
`;

const CloseIcon = styled.i`
  position: absolute;
  right: 6px;
  display: flex;
  align-self: center;
  height: auto !important;
  color: rgba(0, 0, 0, 0.2);
  font-size: 1em !important;
  cursor: pointer;
  transition: 0.2s ease;
  padding: 2px 0px 0px 0px;

  &:hover {
    color: rgba(0, 0, 0, 0.15);
  }
`;

export { ItemWrapper, ValueWrapper, CloseIcon };
